import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import Splash from "./Components/splash.js";
import Header from "./Components/header.js";
import Footer from "./Components/footer.js";
import Home from "./Components/home.js";
import About from "./Components/about.js";
import Projects from "./Components/projects.js";
import Contact from "./Components/contact.js";
import "./css/Desk.css";
import "./css/Responsive.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
    {loading ? (
        <Splash />
      ) : (
      <BrowserRouter>
        <Header/>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/about" element={<About/>}/>
          <Route path="/projects" element={<Projects/>}/>
          <Route path="/contact" element={<Contact/>}/>
        </Routes>
        <Footer/>
      </BrowserRouter>
      )}
    </>
  );
}

export default App;
